import { useEffect, useState } from "react";
import { listContact } from "@/lib/api";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

export default function Admin() {
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [token, setToken] = useState(() => sessionStorage.getItem("sn_admin_token") || "");

  const load = (tok) => {
    if (!tok) return setLoading(false);
    setLoading(true);
    setErr(null);
    listContact(tok)
      .then((m) => {
        sessionStorage.setItem("sn_admin_token", tok);
        setMsgs(m);
      })
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Admin, messages";
    load(token);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Navigation />
      <main className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16 py-16">
        <div className="font-mono-label text-[11px] text-[#9a7218]">
          Admin · contact inbox
        </div>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl text-[#14352a]">
          Messages
        </h1>

        <form
          data-testid="admin-token-form"
          onSubmit={(e) => {
            e.preventDefault();
            load(token);
          }}
          className="mt-6 flex gap-2 max-w-md"
        >
          <input
            data-testid="admin-token-input"
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="Admin token"
            className="flex-1 h-10 px-3 border border-[#e5e0d8] bg-white text-sm"
          />
          <button data-testid="admin-token-submit" type="submit" className="h-10 px-4 bg-[#14352a] text-white text-sm">
            Unlock
          </button>
        </form>
        {loading && <p className="mt-8 text-[#55625b]">Loading…</p>}
        {err && <p className="mt-8 text-red-600">{err}</p>}

        <div data-testid="admin-msg-list" className="mt-10 space-y-4">
          {msgs.length === 0 && !loading && (
            <p className="text-[#86928a]">No messages yet.</p>
          )}
          {msgs.map((m) => (
            <article
              key={m.id}
              data-testid={`admin-msg-${m.id}`}
              className="p-6 bg-white border border-[#e5e0d8]"
            >
              <div className="flex flex-wrap justify-between gap-2 font-mono-label text-[10px] text-[#86928a]">
                <span>{new Date(m.created_at).toLocaleString()}</span>
                <span>{m.source}</span>
              </div>
              <div className="mt-3 text-sm text-[#14352a]">
                <span className="font-medium">{m.name}</span> ·{" "}
                <a
                  href={`mailto:${m.email}`}
                  className="text-[#9a7218] link-underline"
                >
                  {m.email}
                </a>
              </div>
              <p className="mt-3 text-[#14352a] leading-relaxed whitespace-pre-wrap">
                {m.message}
              </p>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
